import { MarketingLayout } from '../../layouts/MarketingLayout';

const milestones = [
  { year: '2022', label: 'Founded with a mission to give people back ownership of their digital identity.' },
  { year: '2023', label: 'Shipped the first WebAuthn-based identity layer and developer SDKs.' },
  { year: '2025', label: 'Launched community governance and crossed 500,000 active members.' },
  { year: '2026', label: 'Public beta of the unified app ecosystem with dozens of partner applications.' },
];

const values = [
  { title: 'User-owned by default', desc: 'Identity, data, and reputation belong to the user — not the app or the platform.' },
  { title: 'Open where it counts', desc: 'Open standards and open SDKs so developers can build without lock-in.' },
  { title: 'Govern in the open', desc: 'Decisions are proposed, debated, and voted on by the community itself.' },
];

export const About = () => {
  return (
    <MarketingLayout
      title="About Keskedo"
      subtitle="We are building the open infrastructure for a more connected, more trustworthy digital ecosystem."
    >
      <section className="space-y-12">
        <div className="bg-slate-50 rounded-2xl border border-slate-100 p-8 md:p-12 space-y-4">
          <h2 className="text-2xl font-bold text-slate-900">Our story</h2>
          <p className="text-slate-600 leading-relaxed">
            Keskedo started from a simple observation: the modern internet asked us to trade convenience for control,
            and most people accepted the trade without realizing what they were giving up. We set out to build a
            platform where biometric identity, secure data, and transparent governance were defaults — not features
            you had to opt into. Today, our ecosystem is used by hundreds of thousands of people and dozens of apps
            that share a single, user-owned foundation.
          </p>
        </div>

        <div className="space-y-6">
          <h2 className="text-2xl font-bold text-slate-900">Milestones</h2>
          <div className="space-y-3">
            {milestones.map((m, i) => (
              <div key={i} className="flex gap-6 p-6 bg-white rounded-2xl border border-slate-200">
                <div className="text-xl font-bold w-16 flex-shrink-0 text-indigo-600">{m.year}</div>
                <p className="text-slate-600 leading-relaxed">{m.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="space-y-6">
          <h2 className="text-2xl font-bold text-slate-900">What we believe</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {values.map((v, i) => (
              <div key={i} className="p-6 bg-white border border-slate-200 rounded-2xl space-y-2">
                <h3 className="font-bold text-slate-900">{v.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
};
